/* eslint-disable */
// tslint:disable
/**
 * profile
 * Описание API сервиса profile
 *
 * OpenAPI spec version: 0.1.0-rc.5
 * Contact: team@uchi.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
  export interface BaseAttributes {
    email: string | null;
    phone: string | null;
    name: string;
    last_name: string | null;
    middle_name: string | null;
    registration_type: string | null;
    /**
     * @description <p>Тип пользователя</p>
     * @type {Api.BaseAttributes.TypeEnum}
     * @memberof BaseAttributes
     */
    type: Api.BaseAttributes.TypeEnum;
    /**
     * @description <p>monolith id</p>
     * @type {number | null}
     * @memberof BaseAttributes
     */
    foreign_id: number | null;
  }

  /**
   * @export
   * @namespace BaseAttributes
   */
  export namespace BaseAttributes {
    /**
     * <p>Тип пользователя</p>
     */
    export enum TypeEnum {
      Student = 'student',
      Parent = 'parent',
      Teacher = 'teacher',
      Superuser = 'superuser',
    }
  }

  export interface GetUserProfile200Response {
    data:
      | Api.GetUserProfile200Response.Data.ObjectValue
      | Api.GetUserProfile200Response.Data.ObjectValue2
      | Api.GetUserProfile200Response.Data.ObjectValue3
      | Api.GetUserProfile200Response.Data.ObjectValue4;
    included?: Api.GetUserProfile200Response.Included[];
  }

  /**
   * @export
   * @namespace GetUserProfile200Response
   */
  export namespace GetUserProfile200Response {
    export type Data =
      | Api.GetUserProfile200Response.Data.ObjectValue
      | Api.GetUserProfile200Response.Data.ObjectValue2
      | Api.GetUserProfile200Response.Data.ObjectValue3
      | Api.GetUserProfile200Response.Data.ObjectValue4;

    /**
     * @export
     * @namespace Data
     */
    export namespace Data {
      export interface ObjectValue {
        id: string;
        type: Api.GetUserProfile200Response.Data.ObjectValue.TypeEnum;
        attributes: Api.GetUserProfile200Response.Data.ObjectValue.Attributes;
        /**
         * @description <p>Associated data</p>
         * @type {Api.Relationships}
         * @memberof ObjectValue
         */
        relationships?: Api.Relationships;
      }

      /**
       * @export
       * @namespace ObjectValue
       */
      export namespace ObjectValue {
        export enum TypeEnum {
          Student = 'student',
        }

        export interface Attributes extends Api.BaseAttributes {
          /**
           * @type {number | null}
           * @memberof Attributes
           */
          level: number | null;
          /**
           * @description <p>Account_id, uuid string</p>
           * @type {string}
           * @memberof Attributes
           */
          account_id: string;
          /**
           * @description <p>Registration date</p>
           * @type {string}
           * @memberof Attributes
           */
          created_at: string;
          invite_code?: string;
          gender?: Api.GetUserProfile200Response.Data.ObjectValue.Attributes.GenderEnum;
          /**
           * @description <p>Basic level avatar URI (svg) for grades 1-4</p>
           * @type {string | null}
           * @memberof Attributes
           */
          avatar?: string | null;
          /**
           * @description <p>Basic level avatar URI (png) for grades 1-4</p>
           * @type {string | null}
           * @memberof Attributes
           */
          avatar_png?: string | null;
          /**
           * @description <p>Custom avatar. Svg. Raw xml string. For grades 5-11</p>
           * @type {string | null}
           * @memberof Attributes
           */
          custom_avatar?: string | null;
          last_activity_at?: Api.GetUserProfile200Response.Data.ObjectValue.Attributes.LastActivityAt | null;
        }

        /**
         * @export
         * @namespace Attributes
         */
        export namespace Attributes {
          export enum GenderEnum {
            Male = 'male',
            Female = 'female',
          }

          export interface LastActivityAt {}
        }
      }

      export interface ObjectValue2 {
        id: string;
        type: Api.GetUserProfile200Response.Data.ObjectValue2.TypeEnum;
        attributes: Api.BaseAttributes;
      }

      /**
       * @export
       * @namespace ObjectValue2
       */
      export namespace ObjectValue2 {
        export enum TypeEnum {
          Parent = 'parent',
        }
      }

      export interface ObjectValue3 {
        id: string;
        type: Api.GetUserProfile200Response.Data.ObjectValue3.TypeEnum;
        attributes: Api.BaseAttributes;
        /**
         * @description <p>Associated data</p>
         * @type {Api.Relationships}
         * @memberof ObjectValue3
         */
        relationships?: Api.Relationships;
      }

      /**
       * @export
       * @namespace ObjectValue3
       */
      export namespace ObjectValue3 {
        export enum TypeEnum {
          Teacher = 'teacher',
        }
      }

      export interface ObjectValue4 {
        id: string;
        type: Api.GetUserProfile200Response.Data.ObjectValue4.TypeEnum;
        attributes: Api.GetUserProfile200Response.Data.ObjectValue4.Attributes;
      }

      /**
       * @export
       * @namespace ObjectValue4
       */
      export namespace ObjectValue4 {
        export enum TypeEnum {
          Superuser = 'superuser',
        }

        export interface Attributes extends Api.BaseAttributes {
          login?: string | null;
        }
      }
    }

    export interface Included {
      id: string;
      type: Api.GetUserProfile200Response.Included.TypeEnum;
      attributes:
        | Api.GetUserProfile200Response.Included.Attributes.ObjectValue
        | Api.GetUserProfile200Response.Included.Attributes.ObjectValue2;
    }

    /**
     * @export
     * @namespace Included
     */
    export namespace Included {
      export enum TypeEnum {
        School = 'school',
        Group = 'group',
      }

      export type Attributes =
        | Api.GetUserProfile200Response.Included.Attributes.ObjectValue
        | Api.GetUserProfile200Response.Included.Attributes.ObjectValue2;

      /**
       * @export
       * @namespace Attributes
       */
      export namespace Attributes {
        export interface ObjectValue {
          /**
           * @description <p>Name of school</p>
           * @type {string | null}
           * @memberof ObjectValue
           */
          name?: string | null;
          /**
           * @description <p>Official title of school</p>
           * @type {string | null}
           * @memberof ObjectValue
           */
          official_title?: string | null;
          time_zone?: string | null;
          /**
           * @type {number | null}
           * @memberof ObjectValue
           */
          payment_type?: number | null;
          /**
           * @type {number | null}
           * @memberof ObjectValue
           */
          school_type?: number | null;
        }

        export interface ObjectValue2 {
          /**
           * @description <p>Name of group</p>
           * @type {string}
           * @memberof ObjectValue2
           */
          name?: string;
          /**
           * @description <p>Invite code of group</p>
           * @type {string}
           * @memberof ObjectValue2
           */
          invite_code?: string;
          /**
           * @description <p>Parallel and level have similar meaning</p>
           * @type {number}
           * @memberof ObjectValue2
           */
          parallel?: number;
          /**
           * @description <p>Id of student school</p>
           * @type {string}
           * @memberof ObjectValue2
           */
          school_id?: string;
        }
      }
    }
  }

  export interface GetUserProfile401Response {
    errors?: Api.GetUserProfile401Response.Error[];
  }

  /**
   * @export
   * @namespace GetUserProfile401Response
   */
  export namespace GetUserProfile401Response {
    export interface Error {
      /**
       * @description <p>Our internal error code</p>
       * @type {number}
       * @memberof Error
       */
      code?: number;
      /**
       * @description <p>Description of common error or error field</p>
       * @type {string}
       * @memberof Error
       */
      title?: string;
      source?: Api.GetUserProfile401Response.Error.Source | null;
    }

    /**
     * @export
     * @namespace Error
     */
    export namespace Error {
      export interface Source {
        /**
         * @description <p>Name of error field, can be absent</p>
         * @type {string}
         * @memberof Source
         */
        field?: string;
      }
    }
  }

  export enum GetUserProfileIncludeEnum {
    School = 'school',
    Group = 'group',
  }

  /**
   * <p>Associated data</p>
   */
  export interface Relationships {
    group?: Api.Relationships.Group;
    school?: Api.Relationships.School;
  }

  /**
   * @export
   * @namespace Relationships
   */
  export namespace Relationships {
    export interface Group {
      data?: Api.Relationships.Group.Data;
    }

    /**
     * @export
     * @namespace Group
     */
    export namespace Group {
      export interface Data {
        /**
         * @description <p>Group uuid</p>
         * @type {string}
         * @memberof Data
         */
        id?: string;
        type?: Api.Relationships.Group.Data.TypeEnum;
      }

      /**
       * @export
       * @namespace Data
       */
      export namespace Data {
        export enum TypeEnum {
          Group = 'group',
        }
      }
    }

    export interface School {
      data?: Api.Relationships.School.Data;
    }

    /**
     * @export
     * @namespace School
     */
    export namespace School {
      export interface Data {
        /**
         * @description <p>School uuid</p>
         * @type {string}
         * @memberof Data
         */
        id?: string;
        type?: Api.Relationships.School.Data.TypeEnum;
      }

      /**
       * @export
       * @namespace Data
       */
      export namespace Data {
        export enum TypeEnum {
          School = 'school',
        }
      }
    }
  }
}
